import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reporting-invoices" }
const _hoisted_2 = { class: "table-footer" }
const _hoisted_3 = { class: "legend" }

import { ref } from "vue";
import dayjs from "dayjs";
import TableFinancialData from "@/components/TableFinancialData.vue";
import GraphLegendItem from "@/components/GraphLegendItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectReportingInvoices',
  props: {
    id: {}
  },
  setup(__props: any) {



const currentDate = ref(dayjs().startOf("y"));

const goBack = () => {
  const previousYear = currentDate.value.subtract(1, "y");
  currentDate.value = previousYear;
};

const goForwards = () => {
  const previousYear = currentDate.value.add(1, "y");
  currentDate.value = previousYear;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TableFinancialData, {
      id: __props.id,
      startDate: currentDate.value,
      onGoBack: goBack,
      onGoForwards: goForwards
    }, null, 8, ["id", "startDate"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createVNode(GraphLegendItem, {
          label: _ctx.$t('legend.toPay'),
          color: "var(--color-danger)"
        }, null, 8, ["label"]),
        _createVNode(GraphLegendItem, {
          label: _ctx.$t('legend.orderToApprove'),
          color: "var(--color-warning)"
        }, null, 8, ["label"])
      ])
    ])
  ]))
}
}

})